<!-- MFITTのシートマップ画面で、車椅子・介護席を選択している場合に、確認を出す -->
<template>
  <ItemDialog ref="confirmSelectedSpecialSeat" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        車いす席、介護席を選択しています。<br/>
        ※車いすをご利用の方、介護をされる方などのためにご用意した座席ですので、ご配慮いただきますようお願いいたします。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="OK" actionType="btn-primary" @clicked="ok()" />
      <ItemButton
        label="キャンセル"
        actionType="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogConfirmSelectedSpecialSeat",
  props: {
    clickOk: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const confirmSelectedSpecialSeat = ref(null);

    const ok = () => {
      props.clickOk();
      confirmSelectedSpecialSeat.value.close();
    };

    const openDialog = () => {
      confirmSelectedSpecialSeat.value.open();
    };

    const closeDialog = () => {
      confirmSelectedSpecialSeat.value.close();
    };

    return {
      confirmSelectedSpecialSeat,
      ok,
      openDialog,
      closeDialog,
    };
  },
};
</script>
